module.exports = __webpack_public_path__ + "static/media/pista_anterior.f48b1f5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/pista_anterior.svg
// module id = 1746
// module chunks = 0